import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronDown } from "lucide-react";

const HERO_IMAGE = "/hero-ricefield.jpg";

export default function HeroSearch() {
  const [q, setQ] = useState("");
  const [loaded, setLoaded] = useState(false);
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    nav(`/dashboard/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <section
      data-testid="hero"
      className="relative w-full overflow-hidden bg-ink"
      style={{ height: "85vh" }}
    >
      <img
        src={HERO_IMAGE}
        alt=""
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-out ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
      />
      {/* Overlay: darker at top (behind heading), lighter at bottom so sunset shows through */}
      <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/40 to-ink/25" />
      {/* Extra vignette behind the centered heading+search for guaranteed contrast */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.45)_0%,rgba(0,0,0,0.15)_45%,transparent_75%)]" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <div className="text-ivory/80 text-[11px] tracking-[0.35em] uppercase mb-4 drop-shadow">
          Est. 2026 · Premium Editorial Library
        </div>
        <h1
          className="font-serif text-ivory text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl drop-shadow-[0_2px_18px_rgba(0,0,0,0.55)]"
          data-testid="hero-title"
        >
          Find the perfect
          <span className="italic text-gold"> image.</span>
        </h1>

        <form
          onSubmit={submit}
          data-testid="hero-search-form"
          className="mt-8 w-full mx-auto flex items-stretch bg-ivory overflow-hidden shadow-2xl ring-1 ring-white/10"
          style={{ maxWidth: "925px", height: "53px", borderRadius: "28px" }}
        >
          <div className="flex items-center gap-1.5 pl-5 pr-3 text-sm text-ink border-r border-border shrink-0">
            Photos <ChevronDown className="h-3.5 w-3.5" />
          </div>
          <div className="flex items-center flex-1 min-w-0 pl-3">
            <Search className="h-4 w-4 text-muted-foreground shrink-0" />
            <input
              data-testid="hero-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder='Try "misty forest", "morning coffee"'
              className="flex-1 h-full px-3 text-sm md:text-base outline-none bg-transparent text-ink placeholder:text-muted-foreground"
              autoFocus
            />
          </div>
          <button
            type="submit"
            data-testid="hero-search-submit"
            className="px-6 md:px-8 bg-gold text-ivory hover:bg-gold/90 transition-colors text-sm tracking-wide shrink-0"
          >
            Search
          </button>
        </form>
      </div>
    </section>
  );
}
